module.exports = __webpack_public_path__ + "static/media/combinable-wall-one-and-two.6bd6f727.jpg";